export default __webpack_public_path__ + "static/a1-e9662b16796333879fa92ffabd1cc4b3.png";